import { QuickLink } from '@interfaces/quick-link.interface';

const SPECIALTIES = 'Specialties';
const TERMINAL_SPECIALTY = 'Terminal Specialty';
const PROCEDURES = 'Procedures';
const TERMINAL_PROCEDURE = 'Terminal Procedure';
const EVENT_CATEGORY = 'quick_search';
const EVENT_NAME_MENU = `gtm.${EVENT_CATEGORY}.select.option`;
const EVENT_NAME_TERMINAL = `gtm.${EVENT_CATEGORY}.select.terminal.option`;

export class QuickLinksGtmTagEvent {
  public name: string;
  public type: QuickLinksGtmTagType;
  public label: string;

  constructor(link: QuickLink, gtmEventSuffix?: string) {
    let name = EVENT_NAME_TERMINAL;
    let type: QuickLinksGtmTagType = TERMINAL_SPECIALTY;
    if (link.children && link.children.length) {
      name = EVENT_NAME_MENU;
      type = SPECIALTIES;
      if (link.children[0].params.procedure_id) {
        type = PROCEDURES;
      }
    } else if (link.params && link.params.procedure_id) {
      type = TERMINAL_PROCEDURE;
    }
    this.name = this.getEventName(name, gtmEventSuffix);
    this.type = type;
    this.label = link.name;
  }

  private getEventName?(name: string, gtmEventCategorySuffix: string): string {
    if (!gtmEventCategorySuffix) {
      return name;
    }
    return name.replace(
      EVENT_CATEGORY,
      `${EVENT_CATEGORY}_${gtmEventCategorySuffix}`
    );
  }
}

export type QuickLinksGtmTagType =
  | 'Specialties'
  | 'Terminal Specialty'
  | 'Procedures'
  | 'Terminal Procedure';
